export default __webpack_public_path__ + "static/media/check-black.2aec6331.svg";